module.exports = "<div class=\"prime-cost-plus-project-view\">\n  <shared-project-view\n    project=\"$ctrl.project\"\n    funding-mode=\"obligation\">\n  </shared-project-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/project-details/views/prime-cost-plus-project-view/prime-cost-plus-project-view.html
// module id = 955
// module chunks = 0